import React, { useEffect, useState } from 'react';
import { adService } from '../api';
import LineChart from './LineChart';
import './StatsModal.css';

const ViewsStatsModal = ({ adId, onClose }) => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        adService.getViewsStats(adId, 30)
            .then(({ data }) => { if (!cancelled) setStats(data); })
            .catch(() => { if (!cancelled) setError('Не удалось загрузить статистику'); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [adId]);

    const series = stats ? [
        { key: 'views', label: 'Просмотры объявления', color: '#136EF3', data: stats.series.map(p => ({ x: new Date(p.date), y: p.views })) },
        { key: 'contacts', label: 'Просмотры контактов', color: '#f2a93b', data: stats.series.map(p => ({ x: new Date(p.date), y: p.contactViews })) },
    ] : [];

    return (
        <div className="stats-modal-overlay" onClick={onClose}>
            <div className="stats-modal" onClick={(e) => e.stopPropagation()}>
                <div className="stats-modal__header">
                    <h3>Просмотры за 30 дней</h3>
                    <button className="stats-modal__close" onClick={onClose}>×</button>
                </div>
                {loading && <div className="stats-modal__loading">Загрузка...</div>}
                {error && <div className="stats-modal__error">{error}</div>}
                {stats && (
                    <>
                        <div className="stats-modal__totals">
                            <div>
                                <span className="stats-modal__totals-value">{stats.totalViews}</span>
                                <span className="stats-modal__totals-label">всего просмотров</span>
                            </div>
                            <div>
                                <span className="stats-modal__totals-value">{stats.todayViews}</span>
                                <span className="stats-modal__totals-label">сегодня</span>
                            </div>
                        </div>
                        <LineChart series={series} />
                    </>
                )}
            </div>
        </div>
    );
};

export default ViewsStatsModal;
